<template>
    <div class="modal fade"
         id="restaurant_area_delivery_fee"
         role="dialog"
         tabindex="-1"
         data-backdrop="static"
         data-keyboard="false"
         aria-labelledby="myModalLabel"
    >
        <div class="modal-dialog"
             role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                            class="modal-title"
                    >
                        {{areaName}}
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group">
                            <label>Select Restaurant</label>
                            <multiselect
                                :options="restaurants"
                                :allow-empty="false"
                                @input="getRestaurantOptimizedBranch"
                                v-model="selectedRestaurant"
                                placeholder="Select Restaurant"
                                label="name"
                                track-by="name"
                            />
                        </div>

                    </div>

                    <div class="row">
                        <div class="form-group">
                            <label>Nearest Branch</label>
                          <a @click="setOptimizeBranchToSelectedBranch"
                             v-if="(this.branchFromDeliveryConfig && this.optimizedBranch.id !== this.branchFromDeliveryConfig) || (optimizedBranch ? selectedBranch.id !== this.optimizedBranch.id : false)"
                             class="align-right small-text"><i>Optimize Branch</i></a>
                            <multiselect
                                :options="allBranches"
                                v-model="selectedBranch"
                                :allow-empty="false"
                                placeholder="Restaurant nearest branch"
                                label="name"
                                track-by="name"
                            />
                          <label><i class="text-danger text-sm small-text">If you update the nearest branch, it will automatically update the restaurant optimized branch.</i></label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group">
                            <label>Delivery Fee</label>
                            <input
                                id="delivery_fee"
                                type="number"
                                v-model="deliveryFee"
                                placeholder="Enter Delivery Fee"
                                class="form-control"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="table-responsive m-t">
                            <table class="table table-striped table-responsive table-bordered">
                                <thead>
                                <tr>
                                    <th>Restaurant Name</th>
                                    <th>Branch Name</th>
                                    <th>Delivery Fee</th>
                                    <th class="text-center"><i class="fa fa-bolt"></i></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="areaDeliveryFeeDetails.length === 0">
                                    <td colspan="5" style="text-align: left">No Delivery Fee Configuration.</td>
                                </tr>
                                <tr v-else
                                    style="white-space: nowrap"
                                    v-for="(restaurant, index) in areaDeliveryFeeDetails"
                                    v-bind:key="index+'_deliveryFee'"
                                >
                                    <td>
                                      {{restaurants.find(e => e.id === restaurant.restaurant).name}}
                                    </td>
                                    <td>
                                      <span v-if="restaurant.branchName">{{ restaurant.branchName }}</span>
                                      <span v-else><i>original optimized branch</i></span>
                                    </td>
                                    <td>
                                        {{restaurant.deliveryFee}}
                                    </td>
                                    <td>
                                        <a class="fa fa-trash fa-lg"
                                           title="Delete"
                                           v-on:click="deleteDeliveryFeeConfig(index)"
                                        />
                                    </td>
                                </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" :disabled="disableBtn" @click="updateDeliveryFeeBtwRestaurantAndArea">Save</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {
    deleteAreaDeliveryFeeOfARestaurant,
    getAreaDeliveryFeeDetails,
    updateAreaDeliveryFeeOfARestaurant
} from "@/api/branchAreaDeliveryFee";
import {getOptimizedBranch} from "@/api/restaurants";
import Multiselect from "vue-multiselect";

export default {
    name: "RestaurantAreaDeliveryFee",
    props: {
      restaurants: {
          type: Array,
          required: true
      }
    },
    components: {
        Multiselect
    },
    data() {
        return {
            areaDeliveryFeeDetails: [],
            selectedRestaurant: null,
            optimizedBranch: null,
            selectedBranch: null,
            allBranches: [],
            deliveryFee: 0.0,
            areaId: 0,
            areaName: '',
            disableBtn : false
        }
    },
  computed: {
    branchFromDeliveryConfig() {
      let areaDeliveryFeeDetails = this.selectedRestaurant && this.areaDeliveryFeeDetails.find(e=>e.restaurant === this.selectedRestaurant.id && e.area === Number(this.areaId))
      return areaDeliveryFeeDetails && areaDeliveryFeeDetails.branchId
    },
  },
    methods: {
        async loadBranchDeliveryFeeDetails (areaId, areaName) {
            this.clearData()
            this.areaId = areaId;
            this.areaName = areaName;
            let areaDeliveryFeeDetailsResp = await getAreaDeliveryFeeDetails(areaId)
                .catch(ex => {
                    this.showErrorMessage(ex)
                });

            if(areaDeliveryFeeDetailsResp.data.status === 200){
                this.areaDeliveryFeeDetails = areaDeliveryFeeDetailsResp.data.body ? areaDeliveryFeeDetailsResp.data.body : [];
            }else{
                this.showErrorMessage(areaDeliveryFeeDetailsResp.data.message);
            }
          console.log(this.areaDeliveryFeeDetails)
            $("#restaurant_area_delivery_fee").modal("show");
        },

        async getRestaurantOptimizedBranch(){
          this.disableBtn = true
            let optimizedBranchResp = await getOptimizedBranch(
                this.selectedRestaurant.id, this.areaId
            ).catch( ex => {
                    this.showErrorMessage(ex)
                });
          let branches = await this.fetchBranchesOfRestaurant(this.selectedRestaurant.id)
          this.allBranches = []
          branches.map(e=>{
            this.allBranches.push({
              "id": e.id,
              "name": e.areasByAreaId.name,
            })
          })
          if(optimizedBranchResp.data.status === 200){
            this.optimizedBranch = {
              "id": optimizedBranchResp.data.body.id,
              "name": optimizedBranchResp.data.body.areasByAreaId.name,
            }
            if (!this.branchFromDeliveryConfig || this.optimizedBranch.id === this.branchFromDeliveryConfig) {
              this.setOptimizeBranchToSelectedBranch()
            } else {
              console.log(this.allBranches.find(e=>e.id === this.branchFromDeliveryConfig))
              this.selectedBranch = this.allBranches.find(e=>e.id === this.branchFromDeliveryConfig)
            }
            this.disableBtn = false
          }
        },

      setOptimizeBranchToSelectedBranch() {
        this.selectedBranch = this.optimizedBranch
      },

        async updateDeliveryFeeBtwRestaurantAndArea(){
            let params = new URLSearchParams();
            params.append("restaurant_id", this.selectedRestaurant.id);
            params.append("branch_id", this.selectedBranch.id);
            params.append("area_id", this.areaId);
            params.append("delivery_fee", this.deliveryFee);
            let response = await updateAreaDeliveryFeeOfARestaurant(params)
                .catch( ex => {
                    this.showErrorMessage(ex);
                });
            if(response.data.status === 200){
                this.areaDeliveryFeeDetails = response.data.body
                if(this.areaDeliveryFeeDetails[this.areaDeliveryFeeDetails.length-1].restaurant.name === null){
                    this.areaDeliveryFeeDetails[this.areaDeliveryFeeDetails.length-1].restaurant.name = this.selectedRestaurant.name
                }
                this.clearData()
            } else{
                this.showErrorMessage(
                    response.data.message
                );
            }
        },

        async deleteDeliveryFeeConfig(index){
            console.log('delivery fee: ', this.areaDeliveryFeeDetails[index].id)
            let isDeleted = await this.confirmFromUserBeforeDeleting(
                "Are you sure you want to delete this delivery fee configuration?"
            );
            if(isDeleted.value){
                this.showLoading();
                let deleteData = await deleteAreaDeliveryFeeOfARestaurant(this.areaDeliveryFeeDetails[index].id)
                    .catch(ex => {
                        this.showErrorMessage(ex)
                    });

                if(deleteData.data.status === 200){
                    this.areaDeliveryFeeDetails.splice(index, 1);
                    Swal.close();
                }else{
                    this.showErrorMessage(deleteData.data.message)
                }
            }
        },

        clearData(){
            this.selectedRestaurant = null;
            this.optimizedBranch = null;
            this.selectedBranch = null;
            this.deliveryFee = 0.0;
            this.allBranches = []
        }
    }
}

</script>


<style scoped>
.small-text {
  font-size: 11px;
}
.align-right {
  float: right;
}
</style>